import { env } from "../configs/EnvironmentConfig";

export const API_BASE_URL = env.API_ENDPOINT_URL;
